
import Icon from "hardcover-ui/components/Icon";
import faChevronDown from "icons/solid/chevron-down.svg";
import classNames from "lib/classNames";
import store from "icons/duotone/store.svg";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import Badge from "hardcover-ui/components/Badge";
import Button from "hardcover-ui/components/Button";
import { getAffiliatesLinks } from "lib/affiliates";
import pluralize from "lib/pluralize";
import { PageSerializersBooksShow } from "types/serializers";

export default function BuyBookButtonButton({
  onClick = () => {},
  loading = false,
  open = false,
  book,
}: {
  onClick?: () => void;
  loading?: boolean;
  open?: boolean;
  book: PageSerializersBooksShow;
}) {
  const affiliateLinks = getAffiliatesLinks(book);

  if (affiliateLinks.length === 0) {
    return false;
  }

  return (
    <Button
      type="button"
      variant="tertiary"
      size="sm"
      data-open={open ? "true" : "false"}
      className={classNames(
        "w-full justify-center",
        open ? `buy-book-button-${book.id}` : ""
      )}
      onClick={onClick}
    >
      <Icon
        icon={store}
        size="md"
        className={open ? `buy-book-button-chevron-${book.id}` : ""}
      />
      <span className="hidden sm:block">Available from</span>
      <span className="block sm:hidden">Buy </span>
      <Badge variant="secondary" className="text-xs">
        {affiliateLinks.length} {pluralize("Seller", affiliateLinks.length)}
      </Badge>
      {loading ? (
        <div className="h-4 w-4 flex justify-center">
          <LoadingSpinner size="sm" />
        </div>
      ) : (
        <Icon icon={faChevronDown} size="sm" />
      )}
    </Button>
  );
}
